import { Routes } from '@angular/router';
import {ClientsComponent} from "./clients/clients.component";
import {ContactsComponent} from "./contacts/contacts.component";
import { EnterpriseSubscriptionGuard } from '../security/enterprise-subscription.guard';
import { PermissionGuard } from '../security/permission.guard';
import { app_permissions } from '../security/app-permissions';

export const partyRoutes: Routes = [
    {
        path: 'party/clients',
        component: ClientsComponent,
        canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
        data: { enterpriseModules: ['PARTNER_MANAGEMENT'], enterpriseFeatureLabel: 'Partner Management', permission: app_permissions.party.records.view }
    },
    {
        path: 'party/contacts',
        component: ContactsComponent,
        canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
        data: { enterpriseModules: ['PARTNER_MANAGEMENT'], enterpriseFeatureLabel: 'Partner Management', permission: app_permissions.party.records.view }
    }
];
